import type {
  ChamberAnalysisResponseInterface,
  ChamberUnitInfoInterface,
} from 'store/chamberAnalysis/types';
import {
  CHAMBER_ANALYSIS,
  CHAMBER_ANALYSIS_RESULT,
} from 'store/chamberAnalysis/types';

export interface ChamberAnalysisRequestActionInterface {
  [extraProps: string]: unknown;
  type: typeof CHAMBER_ANALYSIS;
  payload: {
    key: string;
    chamberUnitInfo: ChamberUnitInfoInterface;
  };
}
export function chamberAnalysisRequest(
  key: string,
  chamberUnitInfo: ChamberUnitInfoInterface,
): ChamberAnalysisRequestActionInterface {
  return {
    type: CHAMBER_ANALYSIS,
    payload: {
      key: key,
      chamberUnitInfo: chamberUnitInfo,
    },
  };
}
export interface ChamberAnalysisResponseActionInterface {
  [extraProps: string]: unknown;
  type: typeof CHAMBER_ANALYSIS_RESULT;
  payload: ChamberAnalysisResponseInterface;
}

export function setChamberAnalysisResult(
  analysisResult: ChamberAnalysisResponseInterface,
): ChamberAnalysisResponseActionInterface {
  return {
    type: CHAMBER_ANALYSIS_RESULT,
    payload: analysisResult,
  };
}
